import axios from "axios";

const CLOUD_NAME = "dcnm63xrf";      // <-- corrige aquí si estaba mal
const UPLOAD_PRESET = "atlantisfish"; // <-- y aquí si estaba mal

export async function uploadImageToCloudinary(file) {
  const data = new FormData();
  data.append("file", file);
  data.append("upload_preset", UPLOAD_PRESET);

  const res = await axios.post(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    data
  );
  return res.data.secure_url;
}

export async function uploadVideoToCloudinary(file) {
  const data = new FormData();
  data.append("file", file);
  data.append("upload_preset", UPLOAD_PRESET);

  const res = await axios.post(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`,
    data
  );
  return res.data.secure_url;
}
